import Input from '../../ui/Input';
import { MONO_CLASS, Mono, Sku } from '../../ui/Mono';
import { FormatQty } from './repackModel';

/**
 * As LINHAS DE SALDO de um pallet, com o campo "quanto sai" por item.
 *
 * Existe uma vez só porque aparece em dois lugares (o pallet de origem e cada
 * destino de um split) e uma segunda cópia divergiria no primeiro ajuste
 * (CLAUDE.md §4).
 *
 * ⚠️ Mostra "tem no pallet" — o número que o backend devolveu — e NUNCA um
 * "vai sobrar": saldo depois é assunto da prévia, que é a conta do servidor.
 */
const QtyLines = ({ label, lines = [], onChangeQty, disabled = false, emptyText = null }) => {
    if (lines.length === 0) {
        return emptyText ? (
            <p className="rounded-lg border border-dashed border-mono-300 px-3 py-4 text-center text-xs text-mono-500 dark:border-mono-700 dark:text-mono-400">
                {emptyText}
            </p>
        ) : null;
    }

    return (
        <ul className="space-y-2">
            {lines.map((line) => (
                <li
                    key={line.key}
                    className="flex flex-wrap items-end gap-3 rounded-lg bg-mono-50 px-3 py-2 dark:bg-mono-900/50"
                >
                    <div className="min-w-0 flex-1">
                        <Sku value={line.sku} className="text-sm font-medium" />
                        {line.name ? (
                            <p className="truncate text-xs text-mono-500 dark:text-mono-400">{line.name}</p>
                        ) : null}
                        <p className="text-xs text-mono-500 dark:text-mono-400">
                            {line.supplier_lot ? (
                                <Mono>{line.supplier_lot}</Mono>
                            ) : (
                                label('wms.repack.without_lot')
                            )}
                            {` · ${label('wms.repack.available')}: `}
                            <Mono className="font-semibold text-black dark:text-white">
                                {FormatQty(line.available)}
                            </Mono>
                        </p>
                    </div>
                    <div className="w-32 shrink-0">
                        <Input
                            label={label('wms.repack.qty_to_move')}
                            value={line.qtyText}
                            onChange={(event) => onChangeQty(line.key, event.target.value)}
                            inputMode="decimal"
                            placeholder="0"
                            disabled={disabled}
                            className={MONO_CLASS}
                        />
                    </div>
                </li>
            ))}
        </ul>
    );
};

export default QtyLines;
